import HttpRequest from './HttpRequest'

const request = new HttpRequest('')

export default request
